import React from "react";
import {
  IoSettingsSharp,
  IoPersonCircleOutline,
  IoHome,
  IoArrowBack,
} from "react-icons/io5";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setVisible } from "../../../store/slices/drawer";
import useAuth from "../../../hooks/useAuth";

import styles from "./header.module.css";

function DefaulHeaderLeft() {
  const navigate = useNavigate();

  const handlePress = () => {
    navigate("/");
  };

  return (
    <button type="button" className="touchable-opacity" onClick={handlePress}>
      <IoPersonCircleOutline type="button" size={32} />
    </button>
  );
}

function DefaulHeaderCenter() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const navigate = useNavigate();
  const handlePress = () => {
    navigate("/premium");
  };

  return !user?.isPremium ? (
    <button type="button" onClick={handlePress} className={`${styles.border}`}>
      <div className="btn btn-brand btn-small text-sm font-extrabold whitespace-nowrap">
        {t("unlockPremium")}
      </div>
    </button>
  ) : null;
}

function DefaulHeaderRight() {
  const dispatch = useDispatch();
  const handlePress = () => {
    dispatch(setVisible(true));
  };

  return (
    <button className="touchable-opacity" onClick={handlePress}>
      <IoSettingsSharp type="button" size={32} />
    </button>
  );
}

export function HomeHeaderLeft() {
  const navigate = useNavigate();

  const handlePress = () => {
    navigate("/home");
  };

  return (
    <button type="button" className="touchable-opacity" onClick={handlePress}>
      <IoHome type="button" size={32} />
    </button>
  );
}

export function BackHeaderLeft({ onClick }) {
  const navigate = useNavigate();

  const handlePress = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(-1);
    }
  };

  return (
    <button type="button" className="touchable-opacity" onClick={handlePress}>
      <IoArrowBack size={32} />
    </button>
  );
}

export default function Header({
  className,
  HeaderLeft,
  HeaderCenter,
  HeaderRight,
}) {
  return (
    <div
      className={`flex justify-between items-center p-4 h-[72px] ${className}`}
    >
      <div className="flex justify-start content-center no-print">
        {HeaderLeft ? <HeaderLeft /> : <DefaulHeaderLeft />}
      </div>
      <div className="flex justify-center content-center no-print">
        {HeaderCenter ? <HeaderCenter /> : <DefaulHeaderCenter />}
      </div>
      <div className="flex justify-end content-center no-print">
        {HeaderRight ? <HeaderRight /> : <DefaulHeaderRight />}
      </div>
    </div>
  );
}

export function NoHeaderScroll({ children, className, onScroll }) {
  return (
    <div
      className={`scroll no-scroll-horizontal h-[calc(100%-72px)] ${className}`}
      onScroll={onScroll}
    >
      {children}
    </div>
  );
}
